import { createFileRoute, Outlet } from "@tanstack/react-router";

export const Route = createFileRoute("/(authenticated)/dashboard/settings")({
  component: SettingsLayout,
});

function SettingsLayout() {
  return (
    <div className="mx-auto flex w-full flex-col gap-8 lg:w-9/10">
      <div className="flex items-center gap-3">
        <h1 className="text-3xl font-bold">Settings</h1>
      </div>

      <Outlet />
    </div>
  );
}
